
import { useState } from 'react';

const faqData = [
  {
    question: '介護保険外サービスとは何ですか？',
    answer:
      '介護保険の適用範囲外で提供されるサービスです。介護保険では対応できない日常生活のサポートや、お話し相手、買い物の付き添いなど、より柔軟で幅広いサービスをご利用いただけます。'
  },
  {
    question: '利用するにはどのような手続きが必要ですか？',
    answer:
      'まずはお電話・メール・LINEでお気軽にご相談ください。ご要望をお伺いした上で、サービス内容やお見積もりをご提案いたします。ご納得いただけましたら、ご契約・サービス開始となります。'
  },
  {
    question: '料金はどのくらいかかりますか？',
    answer:
      'サービスの内容やご利用時間によって異なります。無料相談にてお見積もりをお出ししておりますので、まずはお気軽にお問い合わせください。ご予算に合わせたプランもご提案可能です。'
  },
  {
    question: '急な依頼にも対応してもらえますか？',
    answer:
      'はい、可能な限り対応いたします。スタッフの空き状況によりますが、当日のご依頼にも柔軟に対応できるよう体制を整えております。まずはお電話にてご相談ください。'
  },
  {
    question: 'サービスの対応エリアはどこですか？',
    answer:
      '現在、地域密着型でサービスを提供しております。対応エリアの詳細についてはお問い合わせください。エリア外の場合でも、ご相談に応じて対応できる場合がございます。'
  },
  {
    question: 'どのようなスタッフが来てくれますか？',
    answer:
      '介護や福祉の経験を持つ、研修を受けた専門スタッフがお伺いします。ご利用者様との相性も大切にしており、担当スタッフの変更にも柔軟に対応いたします。'
  }
];

export default function FAQ() {
  // 初期は全て閉じた状態にしたいので null を使用
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    // 同じ項目をクリックしたら閉じ、別の項目なら開く
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="py-20 px-6 bg-gradient-to-b from-orange-50/30 to-white">
      <div className="max-w-4xl mx-auto">
        {/* タイトルエリア */}
        <div className="text-center mb-16">
          <p
            className="text-sm font-light text-gray-400 mb-2 tracking-widest"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            FAQ
          </p>
          <h3
            className="text-4xl md:text-5xl font-black text-gray-800 leading-tight mb-4"
            style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}
          >
            よくある質問
          </h3>
          <p
            className="text-base text-gray-600 font-light"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お客様からよくいただくご質問をまとめました
          </p>
        </div>

        {/* FAQ リスト */}
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl shadow-sm transition-all duration-300 overflow-hidden ${
                openIndex === index ? 'shadow-md' : 'hover:shadow-md'
              }`}
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-6 md:px-8 py-5 text-left cursor-pointer group"
              >
                <div className="flex items-center gap-4 flex-1 min-w-0">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-gradient-to-r from-orange-400 to-pink-400 text-white rounded-full text-sm font-bold">
                    Q
                  </span>
                  <h4
                    className="text-sm md:text-base font-semibold text-gray-800 group-hover:text-orange-600 transition-colors"
                    style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}
                  >
                    <a href={`#faq-${index}`}>{item.question}</a>
                  </h4>
                </div>
                <div
                  className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 ml-4 ${
                    openIndex === index ? 'bg-orange-100 rotate-180' : 'bg-gray-100'
                  }`}
                >
                  <i
                    className={`ri-arrow-down-s-line text-lg ${
                      openIndex === index ? 'text-orange-500' : 'text-gray-400'
                    }`}
                  ></i>
                </div>
              </button>

              {/* Answer panel */}
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
                aria-hidden={openIndex !== index}
              >
                <div className="px-6 md:px-8 pb-6 flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-amber-900/10 text-amber-900 rounded-full text-sm font-bold">
                    A
                  </span>
                  <p
                    className="text-sm text-gray-600 leading-relaxed font-light pt-1"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p
            className="text-sm text-gray-500 mb-4 font-light"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            ご不明な点がございましたら、お気軽にお問い合わせください
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-amber-900 text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-amber-800 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
